import { SourceTypeEnum } from '@/bundles/App/enums';
import { createCustomFieldMixin } from '@/bundles/BaseTable/mixins/createCustomFieldMixin';
import {
  ComparableCustomFieldsEnum,
  getComparableCustomFieldItems,
} from '@/bundles/Comparables/helpers/comparableCustomFieldMapper';

export const ComparableCustomFieldMixin = createCustomFieldMixin<ComparableCustomFieldsEnum>(
  SourceTypeEnum.comparable,
  getComparableCustomFieldItems
);
